export enum TabTypes {
    SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
}

// @depreciated
export const TYPES = TabTypes;

export interface TabAction {
    type: TabTypes;
    tabIndex: number;
}

export default {
    // @depreciated
    TYPES,

    setActiveTab: (tabIndex: number): TabAction => ({
        type: TabTypes.SET_ACTIVE_TAB,
        tabIndex
    })
};
